import React, { useState } from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";
import useMediaQuery from "../../Hooks/useMediaQuery";
import { MdVerticalDistribute } from "react-icons/md";
import { AiOutlineClose } from "react-icons/ai";
import logo from "../../Resource/image/projects/manilogo.png";
import logo1 from "../../Resource/image/projects/MKD.png";

const Link = ({ page, selectedPage, SetselectedPage }) => {
  const lowerCasePage = page.toLowerCase();

  return (
    <AnchorLink
      className={`${selectedPage === lowerCasePage ? "text-yellow" : ""}
      hover:text-yellow  transition duration-500`}
      href={`#${lowerCasePage}`}
      onClick={() => SetselectedPage(lowerCasePage)}
    >
      {page}
    </AnchorLink>
  );
};

export default function Navbar({ isTopRoot, selectedPage, SetselectedPage }) {
  const [isToggle, SetisToggle] = useState(false);
  const isAboveMediumSize = useMediaQuery("(min-width:768px)");
  const navbarBackground = isTopRoot ? "" : "bg-red";
  return (
    <nav className={`${navbarBackground} z-40 w-full fixed top-0 py-3`}>
      <div className="flex items-center justify-between mx-auto w-5/6">
        {/* <h4 className="font-serif text-3xl font-bold text-white">ℳ𝓚𝓓</h4> */}

        <img
          style={{ pointerEvents: "none" }}
          src={isTopRoot ? logo : logo1}
          className=" w-full 
                max-w-[100px] md:max-w-[120px]"
        />

        {isAboveMediumSize ? (
          <div className="flex justify-between gap-16 font-sans text-sm font-semibold">
            <Link
              page="Home"
              selectedPage={selectedPage}
              SetselectedPage={SetselectedPage}
            />
            <Link
              page="Skills"
              selectedPage={selectedPage}
              SetselectedPage={SetselectedPage}
            />
            <Link
              page="Projects"
              selectedPage={selectedPage}
              SetselectedPage={SetselectedPage}
            />
            <Link
              page="Certificate"
              selectedPage={selectedPage}
              SetselectedPage={SetselectedPage}
            />
            <Link
              page="Contact"
              selectedPage={selectedPage}
              SetselectedPage={SetselectedPage}
            />
          </div>
        ) : (
          <MdVerticalDistribute
            size={30}
            onClick={() => SetisToggle(!isToggle)}
            className="text-white cursor-pointer rounded-full"
          />
        )}

        {!isAboveMediumSize && isToggle && (
          <div className="fixed right-0 bottom-0 h-full bg-red w-[300px]">
            <div className="flex justify-end p-12">
              <AiOutlineClose
                className="text-rose-700 cursor-pointer rounded-full hover:text-white"
                size={30}
                onClick={() => SetisToggle(!isToggle)}
              />
            </div>
            <div className="flex flex-col gap-10 ml-[33%] text-2xl text-deep-blue">
              <Link
                page="Home"
                selectedPage={selectedPage}
                SetselectedPage={SetselectedPage}
              />
              <Link
                page="Skills"
                selectedPage={selectedPage}
                SetselectedPage={SetselectedPage}
              />
              <Link
                page="Projects"
                selectedPage={selectedPage}
                SetselectedPage={SetselectedPage}
              />
              <Link
                page="Certificate"
                selectedPage={selectedPage}
                SetselectedPage={SetselectedPage}
              />
              <Link
                page="Contact"
                selectedPage={selectedPage}
                SetselectedPage={SetselectedPage}
              />
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
